/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Box, styled, Typography } from '@mui/material';
import React from 'react';

const DeliveryDetailsView = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Label = styled(Typography)`
  font-weight: 700;
`;
interface Props {
  carrier?: string;
  deliveryAddress?: string;
}

const DeliveryDetails = (props: Props) => {
  return (
    <DeliveryDetailsView>
      <Box>
        <Label variant='body2'>Carrier</Label>
        <Typography variant='body2'>{props.carrier ?? 'Not provided'}</Typography>
      </Box>
      <Box>
        <Label variant='body2'>Delivery address</Label>
        <Typography variant='body2'>{props.deliveryAddress ?? 'Not provided'}</Typography>
      </Box>
    </DeliveryDetailsView>
  );
};

export default DeliveryDetails;
